import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {PendingChangesGuard} from 'src/app/common/can-deactivate/pending-changes-guard.service';
import {MachineDetailsComponent} from './components/machine-details/machine-details.component';
import {MachineDetailsGeneralComponent} from './components/machine-details-general/machine-details-general.component';
import {MachineDetailsDataComponent} from './components/machine-details-data/machine-details-data.component';
import {MachineDetailsChartsComponent} from './components/machine-details-charts/machine-details-charts.component';
import {MachineDetailsIssuesComponent} from './components/machine-details-issues/machine-details-issues.component';
import {MachineDetailsAuditsComponent} from './components/machine-details-audits/machine-details-audits.component';
import {MachineDetailsConfigComponent} from './components/machine-details-config/machine-details-config.component';
import {MANAGE_ADVANCED_MACHINES, MANAGE_AUDITS, VIEW_ALARMS} from '../../common/auth-guard.service';

const routes: Routes = [
  {
    path: '', component: MachineDetailsComponent, children: [
      {path: '', redirectTo: 'general'},
      {path: 'general', component: MachineDetailsGeneralComponent},
      {path: 'data', component: MachineDetailsDataComponent},
      {path: 'charts', component: MachineDetailsChartsComponent},
      {path: 'issues', component: MachineDetailsIssuesComponent, data: VIEW_ALARMS},
      {path: 'audits', component: MachineDetailsAuditsComponent, data: MANAGE_AUDITS},
      {path: 'config', component: MachineDetailsConfigComponent, data: MANAGE_ADVANCED_MACHINES},
    ],
    canDeactivate: [PendingChangesGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MachineDetailsRoutingModule {
}
